/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';
import {
  USAGE_SUMMARY_FETCHING,
  USAGE_SUMMARY_FETCHING_DONE,
  USAGE_SUMMARY_FETCHING_ERROR,
  UsageSummaryActionType
} from 'store/action';
import {IPortalError} from 'utility/error-handler';
import {IUsageSummaryGroup} from 'views/analytics/summary';

export interface IUsageSummaryState {
  isFetching: boolean;
  error: null | IPortalError;
  usageSummary: IUsageSummaryGroup;
}

const defaultState = {
  isFetching: false,
  error: null,
  usageSummary: null
};
const usageSummaryReducer: Reducer<Readonly<IUsageSummaryState>, UsageSummaryActionType> = (
  state: IUsageSummaryState = defaultState,
  action: UsageSummaryActionType
) => {
  switch (action.type) {
    case USAGE_SUMMARY_FETCHING: {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }

    case USAGE_SUMMARY_FETCHING_DONE: {
      return {
        ...state,
        isFetching: false,
        error: null,
        usageSummary: action.payload.data
      };
    }

    case USAGE_SUMMARY_FETCHING_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    default:
      return state;
  }
};

export default usageSummaryReducer;